<template>
    <div class="container">
        <div class="gwLoading-bg">
            <div class="gwLoading-logo">
                <div
                  class="gwLoading-fazhen-xuanzhuan"
                  :style="{ transform: `rotate(${fazhenAngle}deg)` }"
                ></div>
                <div class="gwloading-progress">{{ progress }}%</div>
                <div class="gwloading-progress-text">Loading…</div>
            </div>
        </div> 
    </div>
</template>

<script>
export default {
  name: 'gw-loading',
  data() {
    return {
      loading: false,
      progress: 0,
      fazhenAngle: 90
    }
  },
  mounted() {
    this.animate();
  },
  methods: {
    animate() {
      const duration = 1500; // 动画总时长，单位ms
      const start = performance.now();
      const animateFrame = (now) => {
        const elapsed = now - start;
        const percent = Math.min(elapsed / duration, 1);
        this.progress = Math.round(percent * 100);
        this.fazhenAngle = 90 - 90 * percent;
        if (percent < 1) {
          requestAnimationFrame(animateFrame);
        } else {
          this.progress = 100;
          this.fazhenAngle = 0;
          if (this.$route.path !== '/gw-main') {
            this.$router.replace('/gw-main');
          }
        }
      };
      requestAnimationFrame(animateFrame);
    }
  }
}
</script>
<style lang="scss">
.container {
    width: 100vw;
    height: 100vh;
    position: relative;
}

.gwLoading-bg {
    width: 100vw;
    height: 100vh;
    background-image: url('../assets/gw-loading/bg.jpg');
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.gwLoading-logo {
    background-image: url('../assets/gw-loading/logo.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    width: 34vw;   /* 869/2560 ≈ 0.339 */
    height: 24vh;    /* 303/1080 ≈ 0.28 */
    position: absolute;
    top: 35vh;      /* 100/1080 ≈ 0.093 */
    left: 34.5vw;     /* 100/2560 ≈ 0.039 */
}

.gwLoading-fazhen-xuanzhuan {
    width: 27.2vw;   /* 696/2560 */
    height: 49.8vh;  /* 538/1080 */
    background-image: url('../assets/gw-loading/fazhen-xuanzhuan.png');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    position: absolute;
    top: -11vh;    /* 200/1080 */
    left: 3.3vw;     /* 100/2560 */
}

.gwloading-progress {
    width: 4vw;    /* 132/2560 */
    height: 3vh;   /* 50/1080 */
    font-family: Source Han Serif CN;
    font-weight: 800;
    font-size: 2.5vw; /* 63/1312≈0.048，按大屏适配 */
    color: #FDF3B5;
    position: absolute;
    top: 25vh;     /* 340/1080 */
    left: 14.5vw;    /* 340/2560 */
    z-index: 2;
    pointer-events: none;
}

.gwloading-progress-text {
    width: 14.4vw;   /* 369/2560 */
    height: 3.4vh;   /* 37/1080 */
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 2.8vw; /* 36/1312≈0.028 */
    color: #FFF3B4;
    text-align: center;
    letter-spacing: 2vw;
    line-height: normal;
    position: absolute;
    top: 50vh;     /* 725/1080 */
    left: 4.5vw;     /* 250/2560 */
}
</style>